import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search, TransactionGreen, TransactionRed } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import { formatMoney } from '../../../utils/formatMoney'
import './myTransaction.css'

const FILTERS = ['All', 'Credit', 'Debit']

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

// Confirmed live: `direction` is "in"/"out" and `type`/`txn_type` are
// "credit"/"debit" — `amount_tone` ("positive"/"negative") agrees with both.
const isDebitTxn = (txn) => txn.direction === 'out' || txn.type === 'debit' || txn.txn_type === 'debit' || txn.amount_tone === 'negative'

const MyTransaction = () => {
    const navigate = useNavigate()
    const [activeFilter, setActiveFilter] = useState(0)
    const [search, setSearch] = useState('')
    const [transactions, setTransactions] = useState([])
    const [next, setNext] = useState(null)
    const [loading, setLoading] = useState(true)
    const [loadingMore, setLoadingMore] = useState(false)

    const fetchPage = (page = 1, append = false) => {
        if (page === 1) setLoading(true)
        else setLoadingMore(true)

        service
            .get(endpoints.users.walletTransactions, { page, page_size: 10 }, { silent: true })
            .then(({ data }) => {
                const list = Array.isArray(data?.data) ? data.data : []
                setTransactions((prev) => (append ? [...prev, ...list] : list))
                setNext(data?.next || null)
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false)
                setLoadingMore(false)
            })
    }

    useEffect(() => {
        fetchPage(1, false)
    }, [])

    const handleLoadMore = () => {
        if (!next) return
        try {
            const url = new URL(next)
            const page = url.searchParams.get('page') || '2'
            fetchPage(Number(page), true)
        } catch {
            // malformed next URL — nothing sensible to do
        }
    }

    const filtered = transactions.filter((txn) => {
        if (activeFilter === 1 && isDebitTxn(txn)) return false
        if (activeFilter === 2 && !isDebitTxn(txn)) return false
        if (search.trim()) {
            const haystack = `${txn.title || ''} ${txn.description || ''}`.toLowerCase()
            if (!haystack.includes(search.trim().toLowerCase())) return false
        }
        return true
    })

    return (
        <section className='commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='txnData'>
                            <div className='tripDocHeader mb-4' onClick={() => navigate(-1)}>
                                <BackArrow />
                                <span className='bsSectionTitle'>Transaction History</span>
                            </div>
                            <div className='commonBookingTab'>
                                {FILTERS.map((filter, index) => (
                                    <div
                                        key={filter}
                                        className={`bookTab ${activeFilter === index ? 'active' : ''}`}
                                        onClick={() => setActiveFilter(index)}
                                    >
                                        {filter}
                                    </div>
                                ))}
                            </div>

                            <div className='txnSearchBox mt-4'>
                                <img src={Search} alt="" />
                                <input
                                    type='text'
                                    placeholder='Search Transaction'
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            {/* Total Credit / Total Debit summary — the API only
                                returns a paginated list, no aggregate totals field.
                                Summing just the loaded page(s) would show a wrong,
                                partial number, so this stays off until the backend
                                adds a real totals field. */}
                            {/* <div className='txnSummaryRow mt-4'>
                                <div className='txnSummaryCard'>
                                    <div className='txnSummaryCard__value'>{SUMMARY.totalCredit}</div>
                                    <div className='txnSummaryCard__label'>Total Credit</div>
                                </div>
                                <div className='txnSummaryCard txnSummaryCard--debit'>
                                    <div className='txnSummaryCard__value'>{SUMMARY.totalDebit}</div>
                                    <div className='txnSummaryCard__label'>Total Debit</div>
                                </div>
                            </div> */}

                            <div className='bsSectionTitle mt-4'>{filtered.length} Transactions</div>
                            <div className='txnList bgWhite commonBorder borderRadius20'>
                                {loading ? (
                                    <p className='bsFareNote paddingCommon20'>Loading...</p>
                                ) : filtered.length ? filtered.map((txn, index) => {
                                    const debit = isDebitTxn(txn)
                                    return (
                                        <div className='txnRow' key={txn.id ?? index}>
                                            <span className={`txnRow__icon txnRow__icon--${debit ? 'debit' : 'credit'}`}>
                                                <img src={debit ? TransactionRed : TransactionGreen} alt="" />
                                            </span>
                                            <div className='txnRow__info'>
                                                <div className='txnRow__title'>{txn.title || 'Transaction'}</div>
                                                {txn.description && <div className='txnRow__meta'>{txn.description}</div>}
                                                <div className='txnRow__meta'>{txn.date_label || ''}</div>
                                            </div>
                                            <div className='txnRow__right'>
                                                {/* `signed_amount` already comes pre-formatted with sign + ₹ */}
                                                <span className='txnRow__amount'>
                                                    {txn.signed_amount || formatMoney(txn.amount, txn.currency)}
                                                </span>
                                                {/* No `status` (COMPLETED/FAILED) field in the
                                                    transactions API response — re-enable once
                                                    the backend returns one. */}
                                            </div>
                                        </div>
                                    )
                                }) : (
                                    <p className='bsFareNote paddingCommon20'>No transactions found.</p>
                                )}
                            </div>

                            {next && (
                                <button type='button' className='travellerAddBtn mt-4' onClick={handleLoadMore} disabled={loadingMore}>
                                    {loadingMore ? 'Loading...' : 'Load More'}
                                </button>
                            )}

                            {/* No export/report-generation endpoint documented yet. */}
                            {/* <button type='button' className='travellerAddBtn mt-4'>Download Transaction Report</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MyTransaction
